import { createFileRoute } from '@tanstack/react-router';

import { SectionIndex } from '@/features/app-shell/components/SectionLayout';
import { INTEGRATIONS_TABS } from '@/features/app-shell/navigation';

export const Route = createFileRoute('/workspaces/$workspaceId/integrations/')({
  component: IntegrationsIndexRoute,
});

export function IntegrationsIndexRoute() {
  const { workspaceId } = Route.useParams();
  return <SectionIndex tabs={INTEGRATIONS_TABS} workspaceId={workspaceId} />;
}
